import React, { useState, useRef } from "react";
import clsx from "clsx";

import "./header.css";
import NavigationBar from "./navigationBar";
import NotificationBell from "./notificationBell/notificationBell";
import { useNavigate } from "react-router-dom"
import useOutsideAlerter from "../../utils/clickOutside";
import { useInstitution } from "../../context/InstitutionContext";
import { useMantenedora } from "../../context/MantenedoraContext";
import { useInstitutionTheme } from "../../hooks/useInstitutionTheme";
import { updateStoredState } from "../../utils/localStorage";
import HelpIcon from "../../assets/icons/help.svg";
import UserCaretDown from "../../assets/icons/user-caret-down.svg";
import InstitutionIcon from "../../assets/icons/institution.svg";
import ChevronDown from "../../assets/icons/chevron-icon.svg";

const Header = ({ onHelpClick, isCollapsed, onNotificationAction }) => {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isInstitutionDropdownOpen, setIsInstitutionDropdownOpen] = useState(false);
  const { institution, setInstitution } = useInstitution();
  const {
    institutions,
    hasMultipleInstitutions,
    selectedInstitutionId,
    setSelectedInstitutionId,
    getCurrentInstitution,
    mantenedora
  } = useMantenedora();
  const { logo: customLogo } = useInstitutionTheme();

  const profileDropdownRef = useRef(null);
  const institutionDropdownRef = useRef(null);
  const navigate = useNavigate(); 

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  const toggleInstitutionDropdown = () => {
    if (hasMultipleInstitutions) {
      setIsInstitutionDropdownOpen(!isInstitutionDropdownOpen);
    }
  };

  const handleOutSideClick = () => {
    setIsProfileDropdownOpen(false);
  };

  const handleInstitutionOutsideClick = () => {
    setIsInstitutionDropdownOpen(false);
  };

  const handleSelectInstitution = (inst) => {
    setSelectedInstitutionId(inst.id);
    setInstitution(inst);
    setIsInstitutionDropdownOpen(false);

    // Persiste no localStorage ANTES do reload, pois os useEffect dos contexts
    // não terão tempo de rodar antes do window.location.reload().
    // mantenedora é incluído explicitamente para garantir que o sidebar de
    // gestão da mantenedora continue visível após o reload.
    updateStoredState({
      selectedInstitutionId: inst.id,
      institution: inst,
      mantenedora
    });

    // Recarrega a página para atualizar os dados
    window.location.reload();
  };

  const handleHelp = () => {
    navigate('/app/configuracoes');
    // ACESSO GUIADO DESATIVADO
    // onHelpClick && onHelpClick(); 
  };

  useOutsideAlerter(profileDropdownRef, handleOutSideClick);
  useOutsideAlerter(institutionDropdownRef, handleInstitutionOutsideClick);

  // Determina qual instituição mostrar no header
  const currentInstitution = getCurrentInstitution() || institution;

  return (
    <header className={clsx(isCollapsed && "headerCollapsed")}>
      <div className="header-container">
        <div className="search-container">
          {/* <div className="search-field">
            <img src={SearchIcon} alt="Search" className="search-icon" />

            <input
              type="text"
              className="search-input"
              placeholder="Digite aqui para pesquisar..."
            />
          </div> */}

          <div 
            className={clsx("institution-name", hasMultipleInstitutions && "institution-selector")}
            onClick={toggleInstitutionDropdown}
            ref={institutionDropdownRef}
          >
            {customLogo ? (
              <img src={customLogo} alt="Logo da Instituição" className="institution-logo" />
            ) : (
              <img src={InstitutionIcon} alt="Instituição" className="institution-icon" />
            )}
            <span>{currentInstitution?.name || ""}</span>
            {hasMultipleInstitutions && (
              <img 
                src={ChevronDown} 
                alt="Selecionar" 
                className={clsx("institution-chevron", isInstitutionDropdownOpen && "rotated")} 
              />
            )}

            {isInstitutionDropdownOpen && hasMultipleInstitutions && (
              <div className="institution-dropdown">
                {institutions.map((inst) => (
                  <div
                    key={inst.id}
                    className={clsx(
                      "institution-dropdown-item",
                      inst.id === selectedInstitutionId && "selected"
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectInstitution(inst);
                    }}
                  >
                    <img src={InstitutionIcon} alt="" className="institution-item-icon" />
                    <div className="institution-item-info">
                      <span className="institution-item-name">{inst.name}</span>
                      <span className="institution-item-type">{inst.institutionType}</span>
                    </div>
                    {inst.id === selectedInstitutionId && (
                      <span className="institution-item-check">✓</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="profile-icon-container">
            <NotificationBell onNotificationAction={onNotificationAction} />

            <img
              src={HelpIcon}
              alt="Help"
              className="help-icon"
              onClick={handleHelp}
            />

            <img
              src={UserCaretDown}
              alt="Search"
              className="profile-icon"
              onClick={toggleProfileDropdown}
            />

            {isProfileDropdownOpen && (
              <NavigationBar ref={profileDropdownRef} />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
